import { type FeatureFlags } from "./contexts/FeatureFlagsProvider"

export const enum FeatureFlagNames {}

const getFeatureFlagsConfig = async (): Promise<FeatureFlagsConfig_t> => {
  const features: FeatureFlagsConfig_t = new Map()
  return features
}

type FeatureFlagsConfig_t = Map<FeatureFlags, boolean>

export const loadFeatures = async (): Promise<FeatureFlags[]> => {
  const FeatureFlagsConfig = await getFeatureFlagsConfig()

  const features: FeatureFlags[] = []
  FeatureFlagsConfig.forEach((val, key) => {
    if (val) {
      features.push(key)
    }
  })
  console.log("features:", features)
  return features
}
